import { render, staticRenderFns } from "./combinationDetail.vue?vue&type=template&id=0929896c&"
import script from "./combinationDetail.vue?vue&type=script&lang=js&"
export * from "./combinationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports